import { PivotData, aggregators } from './helper/utils'
import defaultProps from './helper/defaultProps'
import { Plotly } from 'vue-plotly'
function makeRenderer (opts = {}, traceOptions = {}, layoutOptions = {}, transpose = false) {
  const plotlyRenderer = {
    name: opts.name,
    mixins: [defaultProps],
    props: {
      plotlyOptions: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    render (h) {
      const pivotData = new PivotData(this.$props)
      const rowKeys = pivotData.getRowKeys()
      const colKeys = pivotData.getColKeys()
      const traceKeys = transpose ? colKeys : rowKeys
      if (traceKeys.length === 0) traceKeys.push([])
      const datumKeys = transpose ? rowKeys : colKeys
      if (datumKeys.length === 0) datumKeys.push([])

      let fullAggName = this.$props.aggregatorName
      const numInputs = aggregators[fullAggName]([])().numInputs || 0
      if (numInputs !== 0) {
        fullAggName += ` 于 ${this.$props.vals.slice(0, numInputs).join(', ')}`
      }
      const data = traceKeys.map(traceKey => {
        const values = []
        const labels = []
        for (const datumKey of datumKeys) {
          const val = parseFloat(
            pivotData.getAggregator(
              transpose ? datumKey : traceKey,
              transpose ? traceKey : datumKey
            ).value()
          )
          values.push(isFinite(val) ? val : null)
          labels.push(datumKey.join('-') || ' ')
        }
        const trace = { name: traceKey.join('-') || fullAggName }
        if (traceOptions.type === 'pie') {
          trace.values = values
          trace.labels = labels.length > 1 ? labels : [fullAggName]
        } else {
          trace.x = transpose ? values : labels
          trace.y = transpose ? labels : values
        }
        return Object.assign(trace, traceOptions)
      })

      let titleText = fullAggName
      const hAxisTitle = transpose ? this.$props.rows.join('-') : this.$props.cols.join('-')
      const groupByTitle = transpose ? this.$props.cols.join('-') : this.$props.rows.join('-')
      if (hAxisTitle !== '') titleText += ` 于 ${hAxisTitle}`
      if (groupByTitle !== '') titleText += ` 分组于 ${groupByTitle}`

      const layout = {
        title: titleText,
        hovermode: 'closest',
        width: window.innerWidth / 1.5,
        height: window.innerHeight / 1.4 - 50
      }

      if (traceOptions.type === 'pie') {
        const columns = Math.ceil(Math.sqrt(data.length))
        const rows = Math.ceil(data.length / columns)
        layout.grid = { columns, rows }
        data.forEach((d, i) => {
          d.domain = {
            row: Math.floor(i / columns),
            column: i - columns * Math.floor(i / columns)
          }
          if (data.length > 1) {
            d.title = d.name
          }
        })
        if (data[0].labels.length === 1) {
          layout.showlegend = false
        }
      } else {
        layout.xaxis = {
          title: transpose ? fullAggName : null,
          automargin: true
        }
        layout.yaxis = {
          title: transpose ? null : fullAggName,
          automargin: true
        }
      }

      return h(Plotly, {
        props: {
          data,
          layout: {
            ...layout,
            ...layoutOptions,
            ...this.$props.plotlyOptions
          }
        }
      })
    }
  }
  return plotlyRenderer
}
function makeScatterRenderer (opts = {}) {
  const scatterRenderer = {
    name: opts.name,
    mixins: [defaultProps],
    props: {
      plotlyOptions: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    render (h) {
      const pivotData = new PivotData(this.$props)
      const rowKeys = pivotData.getRowKeys()
      const colKeys = pivotData.getColKeys()
      if (rowKeys.length === 0) rowKeys.push([])
      if (colKeys.length === 0) colKeys.push([])

      const data = { x: [], y: [], text: [], type: 'scatter', mode: 'markers' }
      rowKeys.map(rowKey => {
        colKeys.map(colKey => {
          const v = pivotData.getAggregator(rowKey, colKey).value()
          if (v !== null) {
            data.x.push(colKey.join('-'))
            data.y.push(rowKey.join('-'))
            data.text.push(v)
          }
        })
      })

      const layout = {
        title: this.$props.rows.join('-') + ' vs ' + this.$props.cols.join('-'),
        hovermode: 'closest',
        xaxis: { title: this.$props.cols.join('-'), automargin: true },
        yaxis: { title: this.$props.rows.join('-'), automargin: true },
        width: window.innerWidth / 1.5,
        height: window.innerHeight / 1.4 - 50
      }

      return h(Plotly, {
        props: {
          data: [data],
          layout: {
            ...layout,
            ...this.$props.plotlyOptions
          }
        }
      })
    }
  }
  return scatterRenderer
}

export default {
  '分组列柱形图': makeRenderer({ name: 'vue-grouped-column-chart' }, { type: 'bar' }, { barmode: 'group' }),
  '堆栈列柱形图': makeRenderer({ name: 'vue-stacked-column-chart' }, { type: 'bar' }, { barmode: 'relative' }),
  '分组柱形图': makeRenderer({ name: 'groupd-bar-chart' }, { type: 'bar', orientation: 'h' }, { barmode: 'group' }, true),
  '堆栈柱形图': makeRenderer({ name: 'vue-stacked-bar-chart' }, { type: 'bar', orientation: 'h' }, { barmode: 'relative' }, true),
  '折线图': makeRenderer({ name: 'vue-line-chart' }),
  '点图': makeRenderer({ name: 'vue-dot-chart' }, { mode: 'markers' }, {}, true),
  '面积图': makeRenderer({ name: 'vue-area-chart' }, { stackgroup: 1 }),
  '散点图': makeScatterRenderer({ name: 'vue-scatter-chart' }),
  '多项饼图': makeRenderer({ name: 'vue-multiple-pie-chart' }, { type: 'pie', scalegroup: 1, hoverinfo: 'label+value', textinfo: 'none' }, {}, true)
}
